import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";

export default function Share() {
  const navigate = useNavigate();

  const url = window.location.href;
  const urlParams = new URL(url);
  console.log(urlParams);

  const getParamFromUrl = () => {
    const url = window.location.href;
    const urlParams = new URL(url);
    const id = urlParams.searchParams.get("id");
    const page = urlParams.searchParams.get("page");

    return { id, page };
  };

  const redirectToPage = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    console.log(user);
    const { id, page } = getParamFromUrl();

    console.log(id);
    console.log(page);

    if (page == null) return;

    //return;
    if (user) {
      if (user?.role?.role == "student") {
        // return navigate(`/dashboard/${page}/${id}`);
        switch (page) {
          case "report":
            return navigate(`/dashboard/${page}/${id}`);
            break;
          case "interview_invitation":
            return navigate(`/interview-invitation?meetingid=${id}`);

          default:
            alert("Invalid URL");
            break;
        }
      } else if (user?.role?.role == "company") {
        // return navigate(`/company/${page}/${id}`);
        switch (page) {
          case "report":
            return navigate(`/company/${page}/${id}`);
            break;
          case "interview_invitation":
            return navigate(`/interview-invitation?meetingid=${id}`);

          default:
            alert("Invalid URL");
            break;
        }
      }
    } else {
      switch (page) {
        case "report":
          return navigate(`/${page}/${id}`);
          break;
        case "interview_invitation":
          return navigate(`/interview-invitation?meetingid=${id}`);

        default:
          alert("Invalid URL");
          break;
      }
    }

    navigate(`/${page}/${id}`);
  };

  const checkForCredentials = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    console.log(user);
    const id = url.split("/").pop();
    console.log(id);
    // if (user) {
    //     if (user?.role?.role == "student")
    //         navigate(`/report/${id}`);
    //     if (user?.role?.role == "company")
    //         navigate(`/company/report/${id}`);
    // }
  };

  useEffect(() => {
    setTimeout(() => {
      redirectToPage();
    }, 1000);

    // checkForCredentials();
  }, []);

  return (
    <div className="w-screen h-screen">
      <Loader loader={true} text={"Please wait"} />
    </div>
  );
}
